export default __webpack_public_path__ + "static/media/11.bae2a449.png";